module.exports = __webpack_public_path__ + "img/img_feature2_01.e3b52417.png";